__turbopack_context__.v({
  "dialog": "fastly-recovery-module-scss-module__XN4wdq__dialog",
  "frame": "fastly-recovery-module-scss-module__XN4wdq__frame",
  "loading": "fastly-recovery-module-scss-module__XN4wdq__loading",
  "spin-rotation": "fastly-recovery-module-scss-module__XN4wdq__spin-rotation",
  "spinner": "fastly-recovery-module-scss-module__XN4wdq__spinner",
  "verification": "fastly-recovery-module-scss-module__XN4wdq__verification",
});
